import posthog, { PostHogInterface } from "posthog-js";
import { config } from "../config";
import * as Roles from "../models/security/Roles";
import TokenProvider from "../providers/TokenProvider";

export const updatePosthogUserInfo = (posthog: PostHogInterface) => {
    const isLoggedIn = TokenProvider.TokenExistsAndIsNotExpired();
    if (!isLoggedIn) {
        posthog.reset();
        return;
    }

    const token = TokenProvider.GetStoredTokenParsed();

    const userId = token?.nameid;
    const email = token?.sub;
    const roles = token?.roles || [];
    const isStaff = roles.indexOf(Roles.Administrator) > -1;

    posthog.identify(userId, { isStaff });
    posthog.people.set({ email });
};

const initializePostHog = () => {
    const POSTHOG_KEY = config.VITE_POST_HOG_KEY;

    if (POSTHOG_KEY) {
        posthog.init(`${config.VITE_POST_HOG_KEY}`, {
            api_host: "https://app.posthog.com",
            loaded: updatePosthogUserInfo,
            person_profiles: "identified_only" // Don't track anon users
        });
    } else {
        console.warn("`VITE_POST_HOG_KEY` not found in environment variables");
    }
};

export default initializePostHog;
